import { elementType, object } from "prop-types";

import styled from "styled-components";
import { fixToCorner } from "theme";
import { positionVariants } from "theme/constants";

import FnrFade from "UI/FnrFade";
import FnrScaleIt from "UI/FnrScaleIt";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

import CancelButton from "./CancelButton";
import SaveButton from "./SaveButton";

const SDiv = styled("div")`
  position: relative;
`;

const SFnrScaleIt = styled(FnrScaleIt)`
  ${fixToCorner}
  z-index: 101; // make sure it appears above the date field
`;

const InputWithButtons = () => {
  const { inputProps, Input, labelSuffix, showSave } =
    useFnrPencilEditInputContext();

  return (
    <FnrVerticalGap gap={showSave ? 4 : 0}>
      <SDiv>
        <Input aria-label={`input-${labelSuffix}`} {...inputProps} />
        <SFnrScaleIt
          $positionVariant={positionVariants.upperRight}
          $margin={-8}
        >
          <CancelButton />
        </SFnrScaleIt>
      </SDiv>
      <FnrFade show={showSave}>
        <SaveButton />
      </FnrFade>
    </FnrVerticalGap>
  );
};

InputWithButtons.propTypes = { Input: elementType, props: object };

export default InputWithButtons;
